import { loggedOutPath, rootPath } from '../../routes';

if (!process.env.REACT_APP_CLIENT_ID || !process.env.REACT_APP_AUTHORITY) {
  throw new Error('Environment variables are missing');
}

const clientId = process.env.REACT_APP_CLIENT_ID;
const authority = process.env.REACT_APP_AUTHORITY;

if (!clientId || !authority) {
  throw new Error('Environment variables are incomplete');
}

export const msalConfig = {
  auth: {
    clientId,
    authority,
    knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITY],
    redirectUri: rootPath,
    postLogoutRedirectUri: loggedOutPath,
  },
  cache: {
    cacheLocation: 'localStorage',
    //TODO@Piotr, Gosia => in case we have problems with logout try switching to 'true' again
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      // The section below is commented out because it is related to MSAL debugging logs.
      // Should there be any issues with MSAL, it can be uncommented to facilitate issue diagnosis.
      // Don't forget to import { LogLevel } from '@azure/msal-browser';
      // loggerCallback: (level: LogLevel, message: string) => {
      //   if (level === LogLevel.Error) console.error(message);
      //   else if (level === LogLevel.Info) console.info(message);
      //   else if (level === LogLevel.Verbose) console.debug(message);
      //   else if (level === LogLevel.Warning) console.warn(message);
      // },
    },
  },
};
